export const RING_RADIUS = 150
export const RING_CENTER = 210
export const ARROW_SIZE = 14
export const ARROW_HALF = ARROW_SIZE / 2

export const NODE_RADIUS = 27
export const NODE_RING_RADIUS = 36

export const LOOP_NODES = [
  { cx: 210, cy: 60, labelX: 250, labelY: 54, labelAnchor: 'start' },
  { cx: 360, cy: 210, labelX: 380, labelY: 265, labelAnchor: 'middle' },
  { cx: 210, cy: 360, labelX: 175, labelY: 380, labelAnchor: 'end' },
  { cx: 60, cy: 210, labelX: 0, labelY: 160, labelAnchor: 'start', multiline: true },
]

export const getLoopMidAngle = (fromNode, toNode) => {
  const fromAngle = Math.atan2(fromNode.cy - RING_CENTER, fromNode.cx - RING_CENTER)
  const toAngle = Math.atan2(toNode.cy - RING_CENTER, toNode.cx - RING_CENTER)
  if (toAngle < fromAngle) return (fromAngle + toAngle + 2 * Math.PI) / 2
  return (fromAngle + toAngle) / 2
}

const LOOP_ARROW_BASE_ROTATION = 100

export const LOOP_ARROWS = LOOP_NODES.map((node, index) => {
  const nextNode = LOOP_NODES[(index + 1) % LOOP_NODES.length]
  const midAngle = getLoopMidAngle(node, nextNode)
  return {
    x: RING_CENTER + RING_RADIUS * Math.cos(midAngle),
    y: RING_CENTER + RING_RADIUS * Math.sin(midAngle),
    rotation: LOOP_ARROW_BASE_ROTATION + index * 90,
  }
})
